import { useTheme } from '@mui/material';

import { SVGPaletteProps } from './interfaces/svg-palette-props.interface';

export const VoucherIcon = (props: SVGPaletteProps) => {
  const theme = useTheme();
  const color = props.palette
    ? theme.palette[props.palette].dark
    : props.stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.4338 4.0625H18.4375C19.2659 4.0625 19.9375 4.73407 19.9375 5.5625V11.5662C19.9375 11.964 19.7795 12.3455 19.4982 12.6268L12.2482 19.8768C11.6624 20.4626 10.7126 20.4626 10.1268 19.8768L4.12316 13.8732C3.53737 13.2874 3.53737 12.3376 4.12316 11.7518L11.3732 4.50184C11.6545 4.22054 12.036 4.0625 12.4338 4.0625Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M12.4338 4.0625H18.4375C19.2659 4.0625 19.9375 4.73407 19.9375 5.5625V11.5662C19.9375 11.964 19.7795 12.3455 19.4982 12.6268L12.2482 19.8768C11.6624 20.4626 10.7126 20.4626 10.1268 19.8768L4.12316 13.8732C3.53737 13.2874 3.53737 12.3376 4.12316 11.7518L11.3732 4.50184C11.6545 4.22054 12.036 4.0625 12.4338 4.0625Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M12.4338 4.0625H18.4375C19.2659 4.0625 19.9375 4.73407 19.9375 5.5625V11.5662C19.9375 11.964 19.7795 12.3455 19.4982 12.6268L12.2482 19.8768C11.6624 20.4626 10.7126 20.4626 10.1268 19.8768L4.12316 13.8732C3.53737 13.2874 3.53737 12.3376 4.12316 11.7518L11.3732 4.50184C11.6545 4.22054 12.036 4.0625 12.4338 4.0625Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M12.4338 4.0625H18.4375C19.2659 4.0625 19.9375 4.73407 19.9375 5.5625V11.5662C19.9375 11.964 19.7795 12.3455 19.4982 12.6268L12.2482 19.8768C11.6624 20.4626 10.7126 20.4626 10.1268 19.8768L4.12316 13.8732C3.53737 13.2874 3.53737 12.3376 4.12316 11.7518L11.3732 4.50184C11.6545 4.22054 12.036 4.0625 12.4338 4.0625Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <circle
          cx="1.25"
          cy="1.25"
          r="1.25"
          transform="matrix(-1 0 0 1 16.5 7.5)"
          fill={color}
        />
        <circle
          cx="1.25"
          cy="1.25"
          r="1.25"
          transform="matrix(-1 0 0 1 16.5 7.5)"
          fill={color}
        />
        <circle
          cx="1.25"
          cy="1.25"
          r="1.25"
          transform="matrix(-1 0 0 1 16.5 7.5)"
          fill={color}
        />
        <circle
          cx="1.25"
          cy="1.25"
          r="1.25"
          transform="matrix(-1 0 0 1 16.5 7.5)"
          fill={color}
        />
      </svg>
    </svg>
  );
};
